import React, { useState, useEffect, useContext } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from 'react-i18next'

import _ from 'lodash'
import {
    Button,
    Card,
    CardHeader,
    CardBody,
    CardFooter,
    Label,
    FormGroup,
    Form,
    Input,
    InputGroupAddon,
    InputGroupText,
    InputGroup,
    Container,
    Col,
    Row,
} from "reactstrap";

import { UserContext, getFbMessagingPermission } from "context/auth";

import i18n from 'utils/translation/i18n'
import { verifyEmail } from 'main_views/components/Form/validations'

let firebase = window.firebase
let firebaseFirestore = window.firebaseFirestore

function Login() {

    let { t } = useTranslation()
    let user = useContext(UserContext)
    let { loggedIn } = user // is fetching the logged user info

    let [email, setEmail] = useState('')
    let [password, setPassword] = useState('')
    let [loading, setLoading] = useState()
    let [error, setError] = useState()


    useEffect(() => {
        document.body.classList.toggle("login-page")

        return function cleanup() {
            document.body.classList.toggle("login-page");
        }

    }, [])

    useEffect(() => {
        setError()
    }, [email, password])

    const handleLogin = async (e) => {
        e.preventDefault()

        setLoading(true)

        try {
            
            await firebase.auth().signInWithEmailAndPassword(email, password)

            // create a messaging token 
            await getFbMessagingPermission()
            
            setLoading(false)


        } catch (error) {
            console.log("handleLogin -> error", error)
            setError(error.code)
            setLoading()
        }

    }

    return (
        <div className="login-page">
            <Container>
                <Row>

                    <Col className="ml-auto mr-auto" lg="4" md="6">

                        <Form action="handleLogin" className="form" method="POST">

                            <Card className="card-login">

                                <CardHeader>
                                    <CardHeader>
                                        <h3 className="header text-center">{t('login')}</h3>
                                    </CardHeader>
                                </CardHeader>

                                <CardBody>

                                    <CustomInput
                                        title={t('email')}
                                        type='email'
                                        value={email}
                                        placeholder={t('email')}
                                        handelChanges={setEmail}
                                    />

                                    <br />

                                    <CustomInput
                                        title={t('password')}
                                        type='password'
                                        value={password}
                                        placeholder={t('password')}
                                        handelChanges={setPassword}
                                    />

                                    <br />

                                    <Link to='/auth/reset-pass'>{t('forget_your_password')}</Link>

                                    <br />

                                    {!_.isEmpty(error) && (
                                        <p className='text-danger'>{t('incorrect_username_or_password')}</p>
                                    )}

                                </CardBody>

                                <CardFooter>
                                    <Button
                                        type='submit'
                                        block
                                        className="btn-round mb-3"
                                        color="warning"
                                        onClick={handleLogin}
                                        disabled={loading || (loading === false && !loggedIn && !error)}
                                    >{t((loading || (loading === false && !loggedIn && !error)) ? "loading" : "login")}</Button>
                                </CardFooter>

                            </Card>
                        </Form>
                    </Col>
                </Row>
            </Container>

            <div
                className="full-page-background"
                style={{
                    backgroundImage: `url(${require("assets/img/bg/fabio-mangione.jpg")})`,
                }}
            />

        </div>
    );
}

export default Login

export let CustomInput = ({ title, type, placeholder, value, handelChanges, error = '', disabled = false }) => (
    <>
        <Label>{title}</Label>
        <InputGroup className='mb-0'>
            <InputGroupAddon addonType="prepend">
                <InputGroupText>
                    <i className={`nc-icon ${type === 'password' ? 'nc-key-25' : type === 'email' ? 'nc-email-85' : 'nc-single-02'}`} />
                </InputGroupText>
            </InputGroupAddon>
            <Input placeholder={placeholder} type={type ?? 'text'} autoComplete='preventDefault' value={value} onChange={e => handelChanges(e.target.value)} disabled={disabled} />
        </InputGroup>
        {!value && (
            <label className="text-danger">{i18n.t('required')}</label>
        )}
        {(value && type === 'email' && !verifyEmail(value)) && (
            <label className="text-danger">{i18n.t('invalid_email')}</label>
        )}
        {error && (
            <label className="text-danger">{error}</label>
        )}
    </>
)